import ImageWithFallback from '@/components/common/image-with-fallback'
import { Button } from '@/components/ui/button'
import { Eye, FilePen, LinkIcon } from 'lucide-react'
import Link from 'next/link'
import toast from 'react-hot-toast'

export default function ManageChampionshipEventHeader({ event }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="flex items-center gap-4">
        <ImageWithFallback
          alt="Championship Header"
          className="hidden rounded-sm md:block"
          src={event.championship.headerImgUrl}
          fallbackUrl="/img/default/header.webp"
          width={176}
          height={99}
        />

        <div className="flex flex-col">
          <p className="text-p-1 font-medium text-neutral-blue-400">
            Championship
          </p>
          <h1 className="text-h-3 font-semibold">{event.championship.name}</h1>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-2 md:gap-4">
        <Button variant="outline" className="w-full sm:w-auto" asChild>
          <Link
            href={`/c/${event.championship.community.slug || event.championship.communityId}/${event.championshipId}/${event.id}`}
            target="_blank"
          >
            <span className="flex items-center justify-center gap-2">
              <Eye className="h-5 w-5 stroke-white stroke-2" />
              Preview Event
            </span>
          </Link>
        </Button>

        <Button variant="outline" className="w-full sm:w-auto" asChild>
          <Link
            href={`/manage/${event.championship.communityId}/racing/${event.championship.id}/edit/events`}
            target="_blank"
          >
            <span className="flex items-center justify-center gap-2">
              <FilePen className="h-5 w-5 stroke-white stroke-2" />
              Edit Event
            </span>
          </Link>
        </Button>

        <Button
          variant="outline"
          className="w-full gap-2 sm:w-auto"
          onClick={() => {
            navigator.clipboard.writeText(
              `${process.env.NEXT_PUBLIC_BASE_URL}/c/${event.championship.community.slug || event.championship.communityId}/${event.championshipId}/${event.id}`,
            )
            toast.success('Link copied to clipboard')
          }}
        >
          <LinkIcon className="size-4 stroke-shades-0 stroke-2" />
          Share
        </Button>
      </div>
    </div>
  )
}
